import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import redexService from "../../services/redexService";

export const fetchRedex=createAsyncThunk(
    "redex/fetch",
    async()=>{

        return await redexService.getRedex();

    }
);

export const removeRedex=createAsyncThunk(
    "redex/delete",
    async(id)=>{

        await redexService.deleteRedex(id);

        return id;

    }
);

export const addRedex = createAsyncThunk(
    "redex/add",
    async (formData, thunkAPI) => {
        try {
            return await redexService.addRedex(formData);
        } catch (error) {
            return thunkAPI.rejectWithValue(
                error.response?.data?.message
            );
        }
    }
);

const redexSlice=createSlice({

    name:"redex",

    initialState:{
        redex:[],
        loading:false
    },

    reducers:{},

    extraReducers:(builder)=>{

        builder

.addCase(fetchRedex.pending,(state)=>{
    state.loading=true;
})

.addCase(fetchRedex.fulfilled,(state,action)=>{
    state.loading=false;
    state.redex=action.payload;
})

.addCase(fetchRedex.rejected,(state)=>{
    state.loading=false;
})

.addCase(addRedex.fulfilled,(state,action)=>{

    state.redex.unshift(action.payload);

})

.addCase(removeRedex.fulfilled,(state,action)=>{

    state.redex=
    state.redex.filter(
        x=>x._id!==action.payload
    );

});

    }

});

export default redexSlice.reducer;